import type { Dayjs } from 'dayjs';

export interface DashboardDateRuleOptions {
    /** 最新可选日是否为今天；false 表示昨天（看板数据截至昨日） */
    latestIsToday: boolean;
    /** 最多回看天数（下限 = 今天 − maxDaysBack，含）；null / undefined 表示不限 */
    maxDaysBack?: number | null;
}

const DAY = 'YYYY-MM-DD';

/**
 * 看板时间范围的可选日期规则，按"日期字符串"比较，不按时刻比较。
 *
 * now 来自 nowInDashboardTz()，可能是 dayjs tz 固定偏移对象：它 subtract 天数后得到的时刻会沿用旧偏移，
 * 跨夏令时切换点差 1 小时，若再用 isAfter / isBefore（底层仍是时刻比较）会把边界日判错；
 * 但 format 出来的墙钟日期始终正确，所以这里只用 format。current 无论是 tz 格子还是本地格子，
 * format 得到的都是面板上显示的日期标签。
 */
export const isDashboardDateDisabled = (
    current: Dayjs | null | undefined,
    now: Dayjs,
    { latestIsToday, maxDaysBack }: DashboardDateRuleOptions,
): boolean => {
    if (!current) return false;
    const day = current.format(DAY);
    const latest = (latestIsToday ? now : now.subtract(1, 'day')).format(DAY);
    if (day > latest) return true;
    if (maxDaysBack != null && day < now.subtract(maxDaysBack, 'day').format(DAY)) return true;
    return false;
};
